import { ENTITIES } from '@/api/api.constant';
import { LanguageCode } from '@/i18n/languages';
import { Document } from '@/types/documents';
import { apiBaseUrl } from '@/utils/constants';

const fields = (
    [
        'name',
        'id',
        'document.filename_disk',
        'document.id',
        'translations.language',
        'translations.nom',
        'main',
    ] satisfies Array<
        | keyof Document
        | `translations.${keyof Document['translations'][number]}`
        | `document.${keyof Document['document']}`
    >
).join(',');

export async function get$documents(lang: LanguageCode, countryCode?: string): Promise<Document[]> {
    const filter = {
        main: { _eq: true },
        language_code: { _eq: lang },
        ...(countryCode && { countries: { country: { code: { _eq: countryCode } } } }),
    };

    const deep = {
        translations: { _filter: { language: { _eq: lang } } },
    };
    const filterString = encodeURIComponent(JSON.stringify(filter));
    const url = `${apiBaseUrl}${ENTITIES.documents}?fields=${fields}&filter=${filterString}&deep=${deep}`;
    const response = await fetch(url, { cache: 'no-cache' }).then((res) => res.json());
    return response?.data ?? [];
}

export async function getDocumentById(id: string): Promise<Document> {
    const url = `${apiBaseUrl}${ENTITIES.documents}/${id}?fields=${fields}`;
    const response = await fetch(url, { cache: 'no-cache' }).then((res) => res.json());
    return response?.data ?? [];
}
